module.exports = __webpack_public_path__ + "static/media/  (128).fcd12657.jpg";